/* repo/merchant*/
import { omit, isNil, lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { MerchantCodec, Merchant, Data } from "../store/merchant/types";
import { withDecoded, flattenData } from "./";

const MERCHANT = "merchant";

export const idLens = lensPath(["id"]);
export const nameLens = lensPath(["attributes", "Name"]);
export const address1Lens = lensPath(["attributes", "Address1"]);
export const address2Lens = lensPath(["attributes", "Address2"]);
export const suburbLens = lensPath(["attributes", "Suburb"]);
export const mccLens = lensPath(["attributes", "MCC"]);
export const midLens = lensPath(["attributes", "MID"]);

function mapToModel(data: object): Merchant {
  return withDecoded(MerchantCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(merchant: Data): Data {
  if (isNil(merchant.id)) {
    //merchant.attributes = omit(["MID"], merchant.attributes);
    return merchant;
  } else {
    return merchant;
  }
}

export async function fetch(id: string | null, params?: {}): Promise<Merchant> {
  return fetchApi({
    nestedResourcePath: [MERCHANT],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export const search = async (id: string | null, params?: {}) =>  {
  return fetchApi({
    nestedResourcePath: [MERCHANT],
    id: id,
    params: params,
  }).then(response => response?.data);
}

export async function fetchAll(
  id: string | null,
  params?: {}
): Promise<Merchant> {
  return fetchApi({
    nestedResourcePath: ["merchant/fullList"],
    id: id,
    params: params,
  }).then((response) => response.data);
}

export async function save(user: Data): Promise<Merchant> {
  return insertApi({
    nestedResourcePath: [MERCHANT],
    id: user.id,
    data: { data: mapToChageset(user) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: [MERCHANT],
    id: id,
  }).then(() => true);
}
